import { getTypeQuestionnaires } from "~/utils";
import { CustomerAcceptPolitics } from "./CustomerAcceptPolitics";
import { PartnerAcceptPolitics } from "./PartnerAcceptPolitics";

interface Props {
  containerClassName?: string;
}

export const AcceptPolitics = ({ containerClassName }: Props) => {
  const isPartnerTypeQuestionnaires = getTypeQuestionnaires() === "partner";

  return isPartnerTypeQuestionnaires
    ? <PartnerAcceptPolitics containerClassName={containerClassName} />
    : <CustomerAcceptPolitics containerClassName={containerClassName} />;
};

export { CustomerAcceptPolitics } from "./CustomerAcceptPolitics";
export { PartnerAcceptPolitics } from "./PartnerAcceptPolitics";
